import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetValidateBasketAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ChannelManager } from 'common/manager';
import {
  getStoreOrderCapacityAction,
  getStoreStatusForTimeSaga,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { storeOrderSchedulingUnavailable } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { checkForStoreClosing } from 'common/utilities/StoreUtils';
import {
  isMobileDevice,
  getAndCheck,
  getTernaryValue,
  isEmptyObject,
  redirectToHomePage,
  getValueOrDefaultObject,
  getUserType,
  redirectToPaymentFailurePage,
  isStoreTemproryClosed,
  createPayloadForStatusCall,
  isEmptyEvery,
  ParseJsonSafely,
  isFutureTime,
  isFutureDate,
  isSupportedTenantCode,
  isValidObject,
  redirectToCARTPage,
  isCateringDisposition,
  getEmbeddedErrorMessageAnalytic,
  getDispositionNew,
} from 'common/utilities/utils';
import {
  CHECKOUT_CONSTANTS,
  CONTACT_DETAIL_ERROR_TITLE,
  DATE_FORMATS,
  HAND_IT_TO_ME_TEXT,
  LOCAL_STORAGE_KEYS,
  RESIZE,
  SESSION_STORAGE_KEYS,
} from 'common/constants/SharedConstants';
import CheckoutViews from 'organisms/CheckoutViews/container/CheckoutViews';
import {
  checkoutDetailsDefaultValue,
  dispatchOrderActions,
  resetOrderReducer,
  showCheckoutPageErrorAnalytic,
  updateCheckoutContactAnalytics,
  updateCheckoutDetailsWithAppStateReducer,
  updateCheckoutDetailsWithCartData,
  updateCheckoutDetailsWithCartDataTenantReducer,
  updateCheckoutDetailsWithMenuReducer,
  updateCheckoutDetailsWithTenantReducer,
  updateCheckoutDetailsWithPaymentsReducer,
  updateCheckoutDetailsWithPaymentsContentReducer,
  updateCheckoutDetailsWithUserOrderState,
  updateDefaultUserContactDetails,
  updateCheckoutDetailsWithProfileReducer,
  updateCheckoutDetailsWithOrderReducer,
  updateCheckoutDetailsWithOrderReducerTenantReducer,
  dispatchResetOrderAction,
  placeOrderClickHandler,
  isStorePartialOrFullyClosed,
  updateCheckoutDetailsWithTenantBasedFlags,
} from 'common/utilities/CheckoutUtils';
import CONTEXT_REDUCER_MAPPING_KEY from 'common/constants/ContextReducerKeys';
import { showLoader } from '@kfc-global/react-shared/redux/Actions/LoaderAction';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { formatDateTime, getEpochTime, parseInvalidDate } from 'common/utilities/dayJsUtils';
import { updateClickPlaceOrderState } from '../../../common/utilities/PaymentUtils';

const Checkout = props => {
  const dispatch = useDispatch();

  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    cartReducer,
    tenantReducer,
    profileReducer,
    orderReducer,
    appStateReducer,
    postOrderReducer,
    menuReducer,
    paymentsContentReducer,
    paymentsReducer,
    storesReducer,
  } = useSelector(data => data);
  const { cartData = {}, isValidated = false } = cartReducer;
  const { orderCapacity = {}, isOrderCapacityLoading = false } = storesReducer || {};
  const { enableOrderCapacityManagement = false, orderServDateFormat = '' } = tenantReducer || {};
  const dispositionNew = getDispositionNew(userOrderState);
  const storeId = dispositionNew?.store?.id;
  const dateTimeEpoch = getEpochTime(dispositionNew?.date, orderServDateFormat);
  const dateTimeFormatted = formatDateTime(dispositionNew?.date, DATE_FORMATS.YYYYMMDD);
  const selectedTime = formatDateTime(
    parseInvalidDate(dispositionNew?.selectedTime, DATE_FORMATS.hh_mm_A),
    DATE_FORMATS.HHmm,
  );
  const { discountLines = [] } = cartData || {};
  const len = discountLines && discountLines?.length - 1;
  const discountLinesObj = discountLines && discountLines[len];
  const { couponCode = '', amount = '' } = discountLinesObj || {};
  const userParams = appStateReducer?.userStatus;
  const selectedFavouriteAddress = useAppSelector(getPWAstorage);
  const savedAddresses = profileReducer?.savedAddresses;
  const [orderCapacityUpdated, setOrderCapacityUpdated] = useState(false);
  const [shouldDisplayOrderCapacityError, setShouldDisplayOrderCapacityError] = useState(false);
  const { orderAccepted = {} } = getAndCheck(isEmptyObject(postOrderReducer), postOrderReducer);
  const customerDetails = getTernaryValue(
    userOrderState?.isPaymentAdded,
    orderAccepted?.customer,
    profileReducer?.basic,
  );

  const [checkoutDetails, setCheckoutDetails] = useState(checkoutDetailsDefaultValue);

  const updateCheckoutDetails = useCallback(param => {
    setCheckoutDetails && setCheckoutDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  const resizeHandler = () => {
    updateCheckoutDetails({ isMobile: isMobileDevice(window.innerWidth) });
  };

  useEffect(() => {
    orderReducer?.response?.order?.customProperties &&
      updateCheckoutDetails({
        streetNumberValue: orderReducer?.response?.order?.customProperties,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducer?.response?.order?.customProperties]);

  useEffect(() => {
    userOrderStateDispatch({
      type: CONTEXT_REDUCER_MAPPING_KEY.PLACE_ORDER_BUTTON,
      placeOrderButtonEnabled: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userParams?.loggedIn && savedAddresses) {
      const filteredAddress = savedAddresses.filter(addressData => {
        return addressData.name === selectedFavouriteAddress?.selectedFavouriteStoreAddress?.name;
      });
      updateCheckoutDetails({
        userInformation: { value: filteredAddress[0]?.deliveryInstructions },
        selectedFavDeliveryAddress: filteredAddress[0],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedAddresses]);

  useEffect(() => {
    checkoutDetails?.selectedFavDeliveryAddress &&
      updateCheckoutDetails({
        userOption:
          checkoutDetails?.selectedFavDeliveryAddress?.deliveryOptions === HAND_IT_TO_ME_TEXT
            ? CHECKOUT_CONSTANTS?.HAND_IT_TO_ME
            : CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.selectedFavDeliveryAddress]);

  useEffect(() => {
    selectedFavouriteAddress?.selectedLineValueAddress &&
      updateCheckoutDetails({
        selectedAptVal: selectedFavouriteAddress?.selectedLineValueAddress,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFavouriteAddress?.selectedLineValueAddress]);
  /*********************************************************************
   *
   *
   *********************************************************************/
  const { CURRENT_STORE_INFO_STORAGE } = LOCAL_STORAGE_KEYS;
  const currentStoreInfoData = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem(CURRENT_STORE_INFO_STORAGE))
      : userOrderState.currentStoreInfo;
  }, [CURRENT_STORE_INFO_STORAGE, userOrderState.currentStoreInfo]);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.PAYMENT_STATUS, '');
    localStorage.setItem(LOCAL_STORAGE_KEYS.POST_PAYMENT_TYPE, '');
    localStorage.setItem(SESSION_STORAGE_KEYS.POST_PAYMENT_TYPE, '');
    resetOrderReducer({ ...checkoutDetails, dispatch });
    window.addEventListener(RESIZE, resizeHandler);
    updateCheckoutDetails({ dispatch });
    return () => {
      window.removeEventListener(RESIZE, resizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    if (isEmptyObject(tenantReducer) && isEmptyObject(menuReducer)) {
      const { currencyConversionFactor, currencyShortName } = tenantReducer;
      const { flatResponse = [] } = getValueOrDefaultObject(menuReducer);
      const { categoryMapByUrl = {} } = getValueOrDefaultObject(flatResponse);
      const { localized = false, loggedIn = false } = getValueOrDefaultObject(userParams);
      const userType = getUserType(localized, loggedIn);
      updateCheckoutContactAnalytics(
        cartData,
        CHECKOUT_CONSTANTS?.BEGIN_CHECKOUT_CLICK,
        { currencyConversionFactor, currencyShortName },
        categoryMapByUrl,
        userType,
        amount,
        couponCode,
      );
      if (userParams?.loggedIn) {
        updateCheckoutContactAnalytics(
          cartData,
          CHECKOUT_CONSTANTS?.ADD_CONTACT_INFO_CLICK,
          { currencyConversionFactor, currencyShortName },
          categoryMapByUrl,
        );
      }

      updateCheckoutDetailsWithMenuReducer(menuReducer, updateCheckoutDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuReducer]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    // triggering analytics method if user details exists
    if (
      !checkoutDetails?.isUpdateCheckoutContactAnalytics &&
      checkoutDetails?.paymentEnabled &&
      !userParams?.loggedIn
    ) {
      const { currencyConversionFactor, currencyShortName } = tenantReducer;
      const { flatResponse = [] } = getValueOrDefaultObject(menuReducer);
      const { categoryMapByUrl = {} } = getValueOrDefaultObject(flatResponse);
      updateCheckoutContactAnalytics(
        cartData,
        CHECKOUT_CONSTANTS?.ADD_CONTACT_INFO_CLICK,
        { currencyConversionFactor, currencyShortName },
        categoryMapByUrl,
      );
      updateCheckoutDetails({ isUpdateCheckoutContactAnalytics: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.paymentEnabled]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    showCheckoutPageErrorAnalytic(
      orderReducer,
      checkoutDetails?.showPaymentError,
      checkoutDetails?.showPaymentPreValidationError,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducer, checkoutDetails?.showPaymentError, checkoutDetails?.showPaymentPreValidationError]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartData *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    if (
      cartData &&
      cartData?.foodLines?.length > 0 &&
      (cartData?.validationResult || (userParams.loggedIn && orderReducer?.response?.order?.id))
    ) {
      updateCheckoutDetailsWithCartData(cartData, checkoutDetails, updateCheckoutDetails);
    } else if (
      isSupportedTenantCode() &&
      cartData &&
      cartData?.validationResult === null &&
      !orderReducer?.response?.order
    ) {
      redirectToCARTPage(props, false);
    } else {
      redirectToHomePage(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cartData?.id,
    cartData?.total,
    cartData?.availableCollectionPoints,
    cartData?.customer,
    cartData?.allowedTenders,
    cartData?.foodLines,
    cartData?.deliveryAddress,
    window?.google,
  ]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithTenantReducer(tenantReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantReducer?.tenantId]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithProfileReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithProfileReducer(profileReducer, checkoutDetails, updateCheckoutDetails, tenantReducer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileReducer?.pastOrders]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithPaymentsReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithPaymentsReducer(paymentsReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsReducer?.response]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithPaymentsContentReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithPaymentsContentReducer(paymentsContentReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsContentReducer?.tendersContent]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartDataTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithCartDataTenantReducer(cartData, tenantReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.total, tenantReducer?.currencySymbol, tenantReducer?.currencyConversionFactor]);

  /*********************************************************************
   *    *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithTenantBasedFlags(cartData, tenantReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.service, tenantReducer?.componentOptions?.web]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartDataTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetails({ orderReducerError: orderReducer?.error, orderReducerResponse: orderReducer?.response });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducer?.error, orderReducer?.response]);

  useEffect(() => {
    isSupportedTenantCode() &&
      updateCheckoutDetailsWithOrderReducerTenantReducer({ orderReducer, tenantReducer, updateCheckoutDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orderReducer?.response?.order?.id,
    orderReducer?.response?.order?.total,
    tenantReducer?.currencySymbol,
    tenantReducer?.currencyConversionFactor,
  ]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithUserOrderState *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithUserOrderState(
      userOrderState,
      userOrderStateDispatch,
      updateCheckoutDetails,
      checkoutDetails,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userOrderState?.dispositionNew,
    userOrderState?.isPaymentAdded,
    userOrderState?.scheduleModalOpen,
    userOrderState?.placeOrderButtonEnabled,
    userOrderState?.currentStoreInfo,
  ]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithAppStateReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    updateCheckoutDetailsWithAppStateReducer(appStateReducer, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appStateReducer?.userStatus]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    isEmptyObject(customerDetails) &&
      userParams?.loggedIn &&
      updateDefaultUserContactDetails(customerDetails, checkoutDetails, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDetails, appStateReducer?.userStatus]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    if (orderReducer?.error) {
      updateCheckoutDetails({ paymentEnabled: ChannelManager.isBrowser, isClickContinuePayment: false });
      if (!orderReducer?.response?.basketValidationResult?.items?.validationStatus?.status) {
        redirectToCARTPage(props, false);
      } else if (!checkoutDetails?.showErrorPayment) {
        redirectToPaymentFailurePage(props);
      }
    } else if (orderReducer && isValidObject(orderReducer?.response) && isSupportedTenantCode()) {
      updateCheckoutDetailsWithOrderReducer({
        orderReducer,
        updateCheckoutDetails,
        checkoutDetails,
        isRetryPaymentErrorEnabled: props?.location?.isRetryPaymentErrorEnabled,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducer, orderReducer?.response?.order?.id, checkoutDetails?.isCartReducerLoadCount]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    props?.location?.ShowPaymentError
      ? updateCheckoutDetails({ showErrorPayment: true })
      : dispatchResetOrderAction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.location?.ShowPaymentError]);

  /*********************************************************************
   *
   *
   *********************************************************************/
  useEffect(() => {
    isValidated && dispatch(resetValidateBasketAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidated]);

  /*********************************************************************
   * Dispatch to get order capacity
   *
   *********************************************************************/
  useEffect(() => {
    if (enableOrderCapacityManagement && !isOrderCapacityLoading && dateTimeEpoch && !orderCapacityUpdated) {
      dispatch(
        getStoreOrderCapacityAction({
          storeId,
          dateTimeEpoch,
        }),
      );
      setOrderCapacityUpdated(true);
    }
  }, [dateTimeEpoch, dispatch, enableOrderCapacityManagement, isOrderCapacityLoading, orderCapacityUpdated, storeId]);

  /*********************************************************************
   * If we have rechecked order capacity before placing the order
   * then return to payment flow
   *********************************************************************/
  useEffect(() => {
    if (enableOrderCapacityManagement && !isOrderCapacityLoading && checkoutDetails?.recheckOrderCapacityData) {
      const orderCapacityForSelectedDate = orderCapacity?.[storeId]?.[dateTimeFormatted];
      const selectedTimeSlotOrderCapacity =
        orderCapacityForSelectedDate &&
        Object.keys(orderCapacityForSelectedDate) &&
        Object.keys(orderCapacityForSelectedDate).includes(selectedTime)
          ? orderCapacityForSelectedDate[selectedTime]
          : null;
      updateCheckoutDetails({ recheckOrderCapacityData: false });

      if (Number(selectedTimeSlotOrderCapacity) === 0) {
        setShouldDisplayOrderCapacityError(true);
      } else {
        updateClickPlaceOrderState(checkoutDetails, updateCheckoutDetails);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    checkoutDetails?.recheckOrderCapacityData,
    enableOrderCapacityManagement,
    isOrderCapacityLoading,
    updateCheckoutDetails,
  ]);

  /*********************************************************************
   * Display the order capacity error modal
   *
   *********************************************************************/
  useEffect(() => {
    if (shouldDisplayOrderCapacityError) {
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SCHEDULE_MODAL_OPEN,
        scheduleModalOpen: true,
      });
      updateCheckoutDetails({
        scheduleModalOpen: true,
      });
    }
  }, [
    checkoutDetails?.isClickPlaceOrder,
    shouldDisplayOrderCapacityError,
    updateCheckoutDetails,
    userOrderStateDispatch,
  ]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' Render *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    if (checkoutDetails?.isClickPlaceOrder) {
      if (checkoutDetails?.validateStoreStatusOnClickPlaceOrder) {
        const {
          buffertimepmdelivery,
          buffertimepmpickup,
          shouldCheckDropOffAddress,
          enableScheduleOrderFlag,
          enableScheduleOrder,
          enableClickCollectScheduleOrderFlag,
        } = checkoutDetails;
        const dataList = createPayloadForStatusCall(
          [currentStoreInfoData],
          currentStoreInfoData?.service,
          null,
          shouldCheckDropOffAddress,
        );
        const userTimeSlot = cartData?.requestedDateTime?.futureDateTime ?? '';
        const payload = {
          storeid: dataList[0]?.storeId,
          service: dataList[0].service,
          channel: dataList[0].channel,
        };
        const finalPayload = userTimeSlot ? { ...payload, futureDateTimeInEpochFormat: userTimeSlot } : payload;

        const storeStatusSuccessHandler = storeDetails => {
          userOrderStateDispatch({
            type: START_ORDER_CONSTANTS.CURRENT_STORE_INFO,
            value: { ...currentStoreInfoData, id: storeDetails[0]?.storeId, summary: storeDetails?.[0]?.summary },
          });
          const isStorePartialOrFullyClosedFlag = isStorePartialOrFullyClosed(checkoutDetails, storeDetails?.[0]);
          if (
            isStorePartialOrFullyClosedFlag?.isScheduledTimePassedOrStoreClosedErr ||
            isStorePartialOrFullyClosedFlag?.isStoreClosedErr
          ) {
            const isStoreOrderSchedulingUnavailable = storeOrderSchedulingUnavailable(
              storeDetails?.[0],
              enableScheduleOrderFlag,
              enableClickCollectScheduleOrderFlag,
              false,
            );
            const isFutureDateTimeOrder = isFutureDate(storeDetails?.[0]) || isFutureTime(storeDetails?.[0]);
            const isFutureDateTimeOrderAvailableFlag = Boolean(
              isFutureDateTimeOrder && !isStoreOrderSchedulingUnavailable,
            );
            const isTemproryClosed = enableClickCollectScheduleOrderFlag
              ? isStoreTemproryClosed(cartData, storeDetails?.[0]?.summary)
              : false;
            const timeFlag = enableScheduleOrder
              ? checkForStoreClosing(storeDetails, buffertimepmdelivery, buffertimepmpickup)
              : false;
            updateCheckoutDetails({
              store: storeDetails[0],
              currentStoreInfo: storeDetails[0],
              scheduleModalOpen: true,
              isTemproryClosed: isTemproryClosed,
              isFutureDateTimeOrder: isFutureDateTimeOrderAvailableFlag,
              storeClosesSoon: timeFlag,
            });
            userOrderStateDispatch({
              type: START_ORDER_CONSTANTS.SCHEDULE_MODAL_OPEN,
              scheduleModalOpen: true,
            });
          } else {
            placeOrderClickHandler(checkoutDetails, updateCheckoutDetails);
          }
        };
        dispatch(
          getStoreStatusForTimeSaga(
            { data: finalPayload, tenantId: tenantReducer.tenantId },
            storeStatusSuccessHandler,
          ),
        );
      } else {
        placeOrderClickHandler(checkoutDetails, updateCheckoutDetails);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isClickPlaceOrder]);

  useEffect(() => {
    checkoutDetails?.dispatchOrderAction && dispatchOrderActions({ checkoutDetails, updateCheckoutDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.dispatchOrderAction]);

  useEffect(() => {
    checkoutDetails?.showPlaceOrderLoading && dispatch(showLoader());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.showPlaceOrderLoading]);

  const isContactDetailValid =
    (!checkoutDetails.userParams?.loggedIn &&
      !isCateringDisposition(checkoutDetails.type) &&
      checkoutDetails.showPreValidationPaymentContactError &&
      !checkoutDetails.isContactDetailValid) ||
    !checkoutDetails.isCateringSomeOneElseContactDetailsAreValid;

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartDataTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    if (isContactDetailValid) {
      getEmbeddedErrorMessageAnalytic(
        CONTACT_DETAIL_ERROR_TITLE,
        translateWithI18Next(TRANSLATE_MAPPING_KEY?.ADD_CONTACT_TO_ENABLE_PAYMENT),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isContactDetailValid]);

  return (
    checkoutDetails?.tenantId !== '' &&
    checkoutDetails?.basketId !== '' && (
      <CheckoutViews {...props} checkoutDetails={checkoutDetails} updateCheckoutDetails={updateCheckoutDetails} />
    )
  );
};

export default Checkout;
